import React, { createContext, PropsWithChildren, useState } from 'react';
export interface PromptContextProps {
  showSpecsAndTemplatePrompt: boolean;
  setShowSpecsAndTemplatePrompt: (showSpecsAndTemplateDialog: boolean) => void;
  showProductOptionsPrompt: boolean;
  setShowProductOptionsPrompt: (showProductOptions: boolean) => void;
  showValidationErrorPrompt: boolean;
  setShowValidationErrorPrompt: (showValidationError: boolean) => void;
}

const PromptContext = createContext<PromptContextProps>({
  setShowProductOptionsPrompt: () => {
    return;
  },
  setShowSpecsAndTemplatePrompt: () => {
    return;
  },
  setShowValidationErrorPrompt: () => {
    return;
  },
  showProductOptionsPrompt: false,
  showSpecsAndTemplatePrompt: false,
  showValidationErrorPrompt: false,
});

export const usePromptContext = () => {
  const context = React.useContext(PromptContext);

  return { ...context };
};

export const PromptContextProvider = ({ children }: PropsWithChildren) => {
  const [showProductOptionsPrompt, setShowProductOptionsPrompt] = useState(false);
  const [showSpecsAndTemplatePrompt, setShowSpecsAndTemplatePrompt] = useState(false);
  const [showValidationErrorPrompt, setShowValidationErrorPrompt] = useState(false);

  return (
    <PromptContext.Provider
      value={{
        showProductOptionsPrompt,
        showSpecsAndTemplatePrompt,
        showValidationErrorPrompt,
        setShowProductOptionsPrompt,
        setShowSpecsAndTemplatePrompt,
        setShowValidationErrorPrompt,
      }}
    >
      {children}
    </PromptContext.Provider>
  );
};

PromptContextProvider.displayName = 'PromptContextProvider';
